import Header from "../component/Header";
import { useEffect, } from "react";
import useApp from "../context/AppContext";
import { api } from "../utils/api";
import { useNavigate } from "react-router-dom";
import CadastroForm from "../component/CadastroForm";

const DadosCadastrais = () => {
  const {
    setLoading,
    usuario,
    showModalError,
    loaded,
    setFornecedor,
    fornecedor,
    verificaUser,
    setAlteracoes,
  } = useApp();
  const navigate = useNavigate();

  const getFornecedor = () => {
    setLoading(true);
    api(usuario)
      .get("/usuario/dadosCadatrais")
      .then((resp) => {
        setLoading(false);
        if (resp.status === 200) {
          setFornecedor(resp.data.fornecedor);
          setAlteracoes(resp.data.alterarCadastro);
          if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") console.log(resp.data.alterarCadastro)
        } else {
          showModalError(resp.data);
        }
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response.status === 406) {
          localStorage.clear();
          navigate("/login");
        } else if (error.response.status === 400) {
          localStorage.clear();
          navigate("/login");
          showModalError(error.response.data);
        } else showModalError("Erro ao acessar servidor");
      });
  };
  useEffect(() => {
    if (loaded) {
      verificaUser();
      if (!usuario.accessToken) navigate("/login");
      else getFornecedor();
    }
  }, [loaded]);

  return (
    <div className="limiter altbg4">
      <div className="container-interna">
        <div className="wrap-interna p-t-25 p-b-20">
          <Header />

          <div className="wrap-altera-dados">              

            <CadastroForm fornecedor={fornecedor}/>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DadosCadastrais;
